// extracted by mini-css-extract-plugin
export default {"imageContainer":"Cca-z","summaryPar":"Dca-z","ratingCategories":"Eca-z","reviewerInfo":"Fca-z","reviewTypes":"Gca-z","expanded":"Hca-z"};